<template>
    <b-modal id="clinic-change-stock" class="clinic-change-stock" ref="modal" :title="dialog_title" hide-footer>
        <div class="row form-group">
            <div class="col-md-9">
                <input v-model="amount" id="change_stock_amount" type="number" class="form-control" />
                <label for="change_stock_amount" class="wabident-info">Cantidad</label>
            </div>
            <div class="col-md-3">
                <button @click='submit' class="btn-wabident btn-block">
                    {{ dialog_btn }}
                </button>
            </div>
        </div>
    </b-modal>
</template>

<script>
export default {
    data() {
        return {
            product: null,
            mode: 'inc',
            amount: 0,
        }
    },
    computed: {
        dialog_title() {
            return (this.mode == 'inc') ? 'Añadir Stock' : 'Retirar Stock';
        },
        dialog_btn() {
            return (this.mode == 'inc') ? 'Añadir' : 'Retirar';
        },
        ...mapGetters(['msgwindow', 'clinic'])
    },
    methods: {
        show(product, mode = 'inc') {
            this.product = product;
            this.mode = mode;
            this.amount = 0;
            this.$refs.modal.show();
        },
        submit() {
            this.$refs.modal.hide();
            this.msgwindow.info('Actualizando stock ...');

            const operation = (this.mode == 'inc') ? 'incstock' : 'decstock';
            const url = `/product/${this.product.id}/${operation}`;

            axios.post(url, {
                amount: this.amount
            }).then(() => {
                this.msgwindow.success('Stock actualizado');
                this.$emit('submit');
            }).catch(() => {
                this.msgwindow.error('Error actualizando stock');
            }).then(() => {
            });
        },
    },
}
</script>
